const isEmpty = (objectLike = {}) =>
  Boolean(!objectLike || Object.keys(objectLike).length === 0)

export default isEmpty
